import React from 'react';

const Loading = () => (
    <div className="loader">
        <img src="./static/gfx/loader.gif" />
    </div>
);

export default Loading;
